// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_or-0";
export var discountCodeInput = "_or-1";